// Email Editor Constants

export const injectedScript = `
<script>
  (function() {
    if (window.parent && typeof window.parent.handleIframeClick === 'function') {
      document.addEventListener('click', window.parent.handleIframeClick, true);
    }
  })();
</script>
`

export const sectionsToProperties = {
  header: ['headerBgColor', 'logoUrl'],
  hero: ['heroImgUrl'],
  body: ['emailTitle', 'bodyHtml', 'ctaText', 'ctaBackgroundColor'],
  col1: ['col1Image', 'col1Html'],
  col2: ['col2Image', 'col2Html'],
  footer: ['socialMediaLinks'],
  'inbox-preview': ['subject', 'preheaderText']
}

export const propertyTypes = {
  headerBgColor: 'color',
  logoUrl: 'image',
  heroImgUrl: 'image',
  emailTitle: 'text',
  bodyHtml: 'richtext',
  col1Image: 'image',
  col1Html: 'richtext',
  col2Image: 'image',
  col2Html: 'richtext',
  ctaText: 'text',
  ctaBackgroundColor: 'color',
  ctaTextColor: 'color',
  privacyPolicyUrl: 'url',
  termsUrl: 'url',
  socialMediaLinks: 'socialmedia',
  preheaderText: 'multilinetext',
  subject: 'text'
}

export const propertyNames = {
  headerBgColor: 'Header background color',
  logoUrl: 'Logo',
  heroImgUrl: 'Hero image ',
  emailTitle: 'Heading',
  body: 'Body',
  ctaText: 'Button text',
  ctaBackgroundColor: 'Button background color',
  privacyPolicyUrl: 'Privacy policy URL',
  termsUrl: 'Terms of service URL',
  socialMediaLinks: 'Social media links',
  subject: 'Email subject',
  preheaderText: 'Preheader text',
  col1Image: 'Column 1 image',
  col1Html: 'Column 1 content',
  col2Image: 'Column 2 image',
  col2Html: 'Column 2 content',
  ctaTextColor: 'Button text color'
}

export const editableSectionClasses = [
  'mjml-header',
  'mjml-hero',
  'mjml-body',
  'mjml-footer',
  'mjml-col1',
  'mjml-col2',
  'mjml-inbox-preview'
]

export const sections = {
  header: 'header',
  hero: 'hero',
  body: 'body',
  footer: 'footer',
  col1: 'col1',
  col2: 'col2',
  'inbox-preview': 'inbox-preview'
}

export const editableSectionNames = {
  header: 'Header',
  hero: 'Hero',
  body: 'Body',
  footer: 'Footer',
  col1: 'Column 1',
  col2: 'Column 2',
  'inbox-preview': 'Inbox preview'
}

export const defaultEmailState = {
  headerBgColor: '#999999',
  logoUrl: '/sample-hotel-logo.png',
  heroImgUrl: 'https://placehold.co/500x220',
  body: `
Lorem ipsum dolor sit amet consectetur adipisicing elit. ***Necessitatibus explicabo*** quo illo tempora fuga reprehenderit non culpa nemo rem perferendis.

~~Old~~ New Return on *Investment page* lets group managers easily see the value SwayPay brings to all **hotels** under the managament group at a glance. 
`,
  preheaderText: 'This is the preview text',
  subject: 'This is the email subject',
  emailTitle: 'This is a header of the email',
  ctaText: 'Book now!',
  ctaBackgroundColor: '#999999',
  hotelName: 'Kailani Resorts - New York',
  hotelAddress: '123 Apple St, New York, NY 10002',
  privacyPolicyUrl: '#',
  termsUrl: '#',
  socialMediaLinks: [
    { platform: 'facebook', url: '#' },
    { platform: 'twitter', url: '#' },
    { platform: 'instagram', url: '#' },
    { platform: 'linkedin', url: '#' },
    { platform: 'youtube', url: '#' }
  ],
  ctaTextColor: '#ffffff'
}
